import 'css-chunk:src/applications/ReportsApp/pages/Reporting/components/Filter/Filter.scss';export default {
  "dropdownContainer": "_dropdownContainer_1wggd_1",
  "ProjectDropdown": "_ProjectDropdown_1wggd_5",
  "scrollableContent": "_scrollableContent_1wggd_20",
  "stickyFooter": "_stickyFooter_1wggd_27",
  "Checkbox": "_Checkbox_1wggd_35",
  "searchError": "_searchError_1wggd_39",
  "actionButtons": "_actionButtons_1wggd_47"
};